/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Save_Preset_TitleInputs */

const en_subtitle_export_save_preset_title = /** @type {(inputs: Subtitle_Export_Save_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save current settings as a preset`)
};

const fr_subtitle_export_save_preset_title = /** @type {(inputs: Subtitle_Export_Save_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les paramètres actuels comme préréglage`)
};

const de_subtitle_export_save_preset_title = /** @type {(inputs: Subtitle_Export_Save_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Einstellungen als Voreinstellung speichern`)
};

const it_subtitle_export_save_preset_title = /** @type {(inputs: Subtitle_Export_Save_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva le impostazioni correnti come predefinite`)
};

const ru_subtitle_export_save_preset_title = /** @type {(inputs: Subtitle_Export_Save_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраните текущие настройки как предустановку.`)
};

const es_subtitle_export_save_preset_title = /** @type {(inputs: Subtitle_Export_Save_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar la configuración actual como un ajuste preestablecido`)
};

const zh_cn2_subtitle_export_save_preset_title = /** @type {(inputs: Subtitle_Export_Save_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将当前设置保存为预设`)
};

const ja_subtitle_export_save_preset_title = /** @type {(inputs: Subtitle_Export_Save_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の設定をプリセットとして保存する`)
};

const hi_subtitle_export_save_preset_title = /** @type {(inputs: Subtitle_Export_Save_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान सेटिंग्स को प्रीसेट के रूप में सहेजें`)
};

const pt_pt2_subtitle_export_save_preset_title = /** @type {(inputs: Subtitle_Export_Save_Preset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar as configurações atuais como uma predefinição`)
};

/**
* | output |
* | --- |
* | "Save current settings as a preset" |
*
* @param {Subtitle_Export_Save_Preset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_save_preset_title = /** @type {((inputs?: Subtitle_Export_Save_Preset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Save_Preset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_save_preset_title(inputs)
	if (locale === "de") return de_subtitle_export_save_preset_title(inputs)
	if (locale === "it") return it_subtitle_export_save_preset_title(inputs)
	if (locale === "ru") return ru_subtitle_export_save_preset_title(inputs)
	if (locale === "es") return es_subtitle_export_save_preset_title(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_save_preset_title(inputs)
	if (locale === "ja") return ja_subtitle_export_save_preset_title(inputs)
	if (locale === "hi") return hi_subtitle_export_save_preset_title(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_save_preset_title(inputs)
	return en_subtitle_export_save_preset_title(inputs)
});